import React, { HTMLAttributes } from 'react';

import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { NodePartner as Type } from '../../../../types/uncinc_profile/nodes';

import './style.scss';

interface PartnerProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

interface LogoProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  logo?: string;
  title: string;
}

const Logo: React.FC<LogoProps> = ({ logo, title }) => (
  <>
    {logo && (
      <div className="NodePartnerTeaser__logo">
        <Image src={logo} alt={title} />
      </div>
    )}
  </>
);

const NodePartnerTeaser: React.FC<PartnerProps> = ({ entity }) => {
  const partner = entity.toJS();
  const title = partner.title[0].value;
  const logo = partner.field_media_item[0];
  const logoImage = logo?.bundle === 'svg' ? logo?.source : logo?.styles.ratio_1_1_sm;
  const link = partner.field_link[0];
  const linkUrl = link?.alias || link?.uri;
  const linkTitle = link?.title;

  return (
    <div className="NodePartnerTeaser">
      {linkUrl ? (
        <CoreLink
          className="NodePartnerTeaser__link"
          title={linkTitle}
          href={linkUrl}
        >
          <Logo
            logo={logoImage}
            title={title}
          />
        </CoreLink>
      ) : (
        <Logo
          logo={logoImage}
          title={title}
        />
      )}
    </div>
  );
};

export default NodePartnerTeaser;
